import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { NotificationEventType } from '@cyberlabrs/types';
import { restoreAll } from '../restoreAll';

export interface Notification {
    userSub: string;
    eventId: string;
    type: NotificationEventType;
    createdAt: string;
    body?: any;
}

export interface NotificationsState {
    allNotifications: Notification[];
    previousLength: number;
}

const initialState: NotificationsState = {
    allNotifications: [],
    previousLength: 0,
};

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        addNotification: (state, action) => {
            state.previousLength = state.allNotifications.length;
            state.allNotifications.push(action.payload);
        },
        removeNotificaton: (state, action) => {
            state.previousLength = state.allNotifications.length;
            state.allNotifications = state.allNotifications.filter(nt => nt.eventId !== action.payload);
        },
    },
});

export const { addNotification, removeNotificaton } = notificationsSlice.actions;

export const selectNotifications = (state: RootState) => state.notifications.allNotifications;
export const selectPreviousLength = (state: RootState) => state.notifications.previousLength;

export default notificationsSlice.reducer;
